const translations = {
  en: {
    "Plans every step and keeps it moving with you":
      "Plans every step and keeps it moving with you",
    "Always watching everything tied to this goal":
      "Always watching everything tied to this goal",
    "Tells you the moment there’s news or something to do":
      "Tells you the moment there’s news or something to do",
    "You change, Ed adjusts the plan": "You change, Ed adjusts the plan",
    "Put your idle cash to work": "Put your idle cash to work",
    "≈$40k sitting idle → a 4.5% position.":
      "≈$40k sitting idle → a 4.5% position.",
    "Lock a sharper mortgage rate": "Lock a sharper mortgage rate",
    "Your refinance window is open right now.":
      "Your refinance window is open right now.",
    "Rebalance to reach $1M sooner": "Rebalance to reach $1M sooner",
    "Top up your emergency buffer": "Top up your emergency buffer",
    "Shift your mix so the milestone arrives years earlier.":
      "Shift your mix so the milestone arrives years earlier.",
    "Build a 6-month safety net": "Build a 6-month safety net",
    "Your goal": "Your goal",
    "Your income came late": "Your income came late",
    "Savings rates moved": "Savings rates moved",
    "A bill went up": "A bill went up",
    "NVDA ranking watch moved": "NVDA ranking watch moved",
    "It slipped out of the top 3 on profitability.":
      "It slipped out of the top 3 on profitability.",
    "A better rate just opened up": "A better rate just opened up",
    "It beats the one you're on. I'll show you where.":
      "It beats the one you're on. I'll show you where.",
    "Heads up — a bill went up": "Heads up — a bill went up",
    "It eats into this month's set-aside. Want me to adjust?":
      "It eats into this month's set-aside. Want me to adjust?",
    now: "now",
    "Previous goal paywall slide": "Previous goal paywall slide",
    "Next goal paywall slide": "Next goal paywall slide",
    "Goal paywall progress": "Goal paywall progress",
  },
  "zh-tw": {
    "Plans every step and keeps it moving with you": "規劃每一步，陪你持續前進",
    "Always watching everything tied to this goal": "持續關注與這個目標相關的一切",
    "Tells you the moment there’s news or something to do": "有新消息或需要行動時立即通知你",
    "You change, Ed adjusts the plan": "你的情況改變，Ed 會調整計畫",
    "Put your idle cash to work": "讓閒置現金發揮作用",
    "≈$40k sitting idle → a 4.5% position.": "約 $40K 閒置資金 → 配置至 4.5% 方案。",
    "Lock a sharper mortgage rate": "鎖定更優惠的房貸利率",
    "Your refinance window is open right now.": "現在正是重新貸款的時機。",
    "Rebalance to reach $1M sooner": "重新配置，提早達到 $1M",
    "Top up your emergency buffer": "補足緊急預備金",
    "Shift your mix so the milestone arrives years earlier.": "調整配置，讓你提早數年達到里程碑。",
    "Build a 6-month safety net": "建立 6 個月的安全預備金",
    "Your goal": "你的目標",
    "Your income came late": "你的收入延遲入帳",
    "Savings rates moved": "儲蓄利率有變化",
    "A bill went up": "帳單金額增加",
    "NVDA ranking watch moved": "NVDA 排名追蹤有變動",
    "It slipped out of the top 3 on profitability.": "它在獲利能力上跌出前三名。",
    "A better rate just opened up": "更優惠的利率出現了",
    "It beats the one you're on. I'll show you where.":
      "比你目前的利率更好。我來告訴你在哪裡。",
    "Heads up — a bill went up": "提醒你，一筆帳單漲價了",
    "It eats into this month's set-aside. Want me to adjust?":
      "這會影響本月預留的資金，要我幫你調整嗎？",
    now: "剛剛",
    "Previous goal paywall slide": "上一張目標付費牆投影片",
    "Next goal paywall slide": "下一張目標付費牆投影片",
    "Goal paywall progress": "目標付費牆進度",
  },
} as const;

export default translations;
